import type { ReactNode } from "react";

import { OLDER_DATA_UNAVAILABLE_COPY } from "@/routes/request-logs/search/older-data";

interface UnavailableSuggestionsSectionProps {
  children: ReactNode;
  reason?: string;
}

const UnavailableSuggestionsSection = ({
  children,
  reason = OLDER_DATA_UNAVAILABLE_COPY,
}: UnavailableSuggestionsSectionProps) => (
  <>
    <li role="presentation" className="mx-2 mt-1 px-2.5 py-1">
      <div aria-hidden className="h-px w-full bg-slate-100" />
    </li>
    <li role="presentation" className="px-4 pb-2 pt-1 text-xs text-slate-500">
      {reason}
    </li>
    {children}
  </>
);

export default UnavailableSuggestionsSection;
